import React from 'react';
import './ServiceOfferingScreen.css';

const ServiceOfferingScreen = ({ onNext, onBack, onDataUpdate, data }) => {
  return (
    <div className="service-offering-screen">
      <h1>Service Offering</h1>
      <p>Coming soon...</p>
      <div className="form-actions">
        <button onClick={onBack} className="back-button">
          Back
        </button>
        <button onClick={onNext} className="next-button">
          Next
        </button>
      </div>
    </div>
  );
};

export default ServiceOfferingScreen; 